import { Component } from '@angular/core';
import {IconComponent} from '../../../../elements/icon/icon.component';
import {Icons} from '../../../../../model/icon';
import {FormsModule} from '@angular/forms';
import {NgIf} from '@angular/common';
import {TelegramService} from '../../../../../services/telegram.service';

@Component({
  selector: 'app-registration-section',
  imports: [
    IconComponent,
    FormsModule,
    NgIf
  ],
  templateUrl: './registration-section.component.html',
  styleUrl: './registration-section.component.scss'
})
export class RegistrationSectionComponent {
  applicantName: string = '';
  juniorName: string = '';
  jersey: string = '';
  form: string = '';



  juniorBirthDate: string = '';
  applicantPhone: string = '';
  applicantMail: string = '';
  juniorTeam: string = '';
  additionalInfo: string = '';

  submit: boolean = false;
  checkbox: boolean = false;
  file: string = 'app/assets/files/test.pdf';
  alert: boolean = false;

  constructor(private telegramService: TelegramService) {
  }

  onInput(textarea: HTMLTextAreaElement): void {
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  onSubmit() {
    if (this.checkbox) {
      this.submit = true;
      this.alert = false;
      const message = `*Новая заявка*\n` +
        `*ФИО заявителя:* ${this.applicantName}\n`+
        `*ФИО игрока:* ${this.juniorName}\n` +
        `*Размер джерси:* ${this.jersey}\n` +
        `*Размер формы для ОФП:* ${this.form}\n` +
        `*Год рождения игрока:* ${this.juniorBirthDate}\n` +
        `*Номер телефона заявителя:* ${this.applicantPhone}\n` +
        `*Почта заявителя:* ${this.applicantMail}\n` +
        `*Команда:* ${this.juniorTeam}\n` +
        `*Информация, о которой желаете сообщить дополнительно:* ${this.additionalInfo}\n`;
      this.telegramService.onSubmit(message);
      this.alert = false;
      this.applicantName = '';
      this.juniorName = '';
      this.jersey = '';
      this.form = '';
      this.form = '';
      this.applicantPhone = '';
      this.juniorBirthDate = '';
      this.juniorTeam = '';
      this.additionalInfo = '';
      this.applicantMail = '';
      setTimeout(() => {
        this.submit = false;
      }, 3000);
    } else {
      this.alert = true;
    }

  }

  protected readonly Icons = Icons;
}
